import React, { useState } from 'react';
import {NavLink, useNavigate } from 'react-router-dom'

import  useUserStore  from '../stores/UserStore'
import  useBackendCheckStore  from '../stores/BackendCheckStore';

import { RxAvatar } from "react-icons/rx";
import { RiRobot3Line } from "react-icons/ri";
import { AiFillHome } from "react-icons/ai";

function Login() {
    const {loginUser} = useUserStore()
    const {setToConnected} = useBackendCheckStore()

    const [username, setUserName] = useState();
    const [password, setPassword] = useState();
    const [alrtMsg, setAlrtMsg] = useState(null)
    const [alert, setAlertOn] = useState(false)

    const handleSubmit = async e => {
        e.preventDefault();
        try {
          await loginUser({
            username,
            password
          });
          setAlrtMsg('')
          setAlertOn(false)
          setToConnected()
        } catch (error) {
            console.log("Error login in", error);
            setAlrtMsg("Invalid username or password.")
            setAlertOn(true)
          }   
      }

  return (
    <div className='login_container'>
      <NavLink className="link" to='/'><AiFillHome className='home_icon'/></NavLink>
        <form onSubmit={handleSubmit} className="login_form">
            
            <div className="login_inputs_container">

                <input className="input" placeholder='Username' type="text" onChange={e => setUserName(e.target.value)} onKeyDown={(e) => {if (e.key === "Enter") {handleSubmit(e);}}}/>
                <input className="input" placeholder='Password' type="password" onChange={e => setPassword(e.target.value)} onKeyDown={(e) => {if (e.key === "Enter") {handleSubmit(e);}}}/>
                {alert ? <p>{alrtMsg}</p> : null}
            </div>
            <button className="btn login_btn" type="submit" onClick={(e) => {handleSubmit(e)}}>Login</button>
        </form>

    </div>
  )
}

export default Login